import React from 'react'
import { Card, Field, Label, Input } from '../../../atoms'

const LoanRepaymentCalculator = () => {
  return (
    <Card data-loan-repayment-calculator className='LoanRepaymentCalculator' variant='plum'>
      <div className='LoanRepaymentCalculator-fields'>
        <Field stack={true}>
          <Label>I wish to borrow:</Label>
          <Input name='loan-amount' prefix='£' format='thousands' value='7500' />
        </Field>
        <Field stack={true}>
          <Label>over:</Label>
          <Input name='loan-duration' suffix=' years' value='5' />
        </Field>
        <Field stack={true}>
          <Label>at an APR of:</Label>
          <Input name='loan-apr' suffix='%' value='3.7' />
        </Field>
      </div>

      <div className='LoanRepaymentCalculator-results'>
        <p className='LoanRepaymentCalculator-compliance-text'>
          The costs below are for illustrative purposes. Check the exact amounts with the lender
          when you decide on a loan.
        </p>
        <div className='LoanRepaymentCalculator-results-row'>
          <div className='LoanRepaymentCalculator-results-cell'>
            <p className='LoanRepaymentCalculator-results-label'>A monthly payment of:</p>
            <p
              className='LoanRepaymentCalculator-results-value'
              data-loan-repayment-calculator-monthly-payments
            >
              £137.11
            </p>
          </div>
          <div className='LoanRepaymentCalculator-results-cell'>
            <p className='LoanRepaymentCalculator-results-label'>Total cost of credit:</p>
            <p
              className='LoanRepaymentCalculator-results-value'
              data-loan-repayment-calculator-cost-of-credit
            >
              £726.65
            </p>
          </div>
        </div>

        <div className='LoanRepaymentCalculator-results-row'>
          <div className='LoanRepaymentCalculator-results-cell'>
            <p className='LoanRepaymentCalculator-results-label'>based on an APR of:</p>
            <p className='LoanRepaymentCalculator-results-value' data-loan-repayment-calculator-apr>
              3.7%
            </p>
          </div>
          <div className='LoanRepaymentCalculator-results-cell'>
            <p className='LoanRepaymentCalculator-results-label'>That&apos;s a total of:</p>
            <p
              className='LoanRepaymentCalculator-results-value'
              data-loan-repayment-calculator-total
            >
              £8,226.65
            </p>
          </div>
        </div>
      </div>

      <p className='LoanRepaymentCalculator-links-title'>Find a loan now</p>

      <div className='LoanRepaymentCalculator-links'>
        <a href='/loans/unsecured-loans'>Personal</a>
        <a href='/loans/bad-credit-loans'>Bad Credit</a>
        <a href='/loans/guarantor-loans'>Guarantor</a>
        <a href='/business/business-loans'>Business</a>
      </div>

      <details>
        <summary>Unsure on which type of loan you&apos;re after?</summary>
        <div className='LoanRepaymentCalculator-more-info'>
          <p className='LoanRepaymentCalculator-more-info-title'>Personal loans</p>

          <p className='LoanRepaymentCalculator-more-info-text'>
            A personal loan is a type of unsecured loan, which means what you borrow isn&apos;t
            secured against any asset like your home. You borrow a fixed amount and pay it back plus
            interest over a set period.
          </p>

          <p className='LoanRepaymentCalculator-more-info-title'>Bad credit loans</p>

          <p className='LoanRepaymentCalculator-more-info-text'>
            If you have a poor credit history, you could still borrow money with a bad credit loan.
            They can help you improve your credit rating if you keep up with repayments, but they
            usually come with a high APR.
          </p>

          <p className='LoanRepaymentCalculator-more-info-title'>Guarantor loans</p>

          <p className='LoanRepaymentCalculator-more-info-text'>
            A guarantor loan works by appointing someone else, like a parent or friend, to make your
            loan repayments if you&apos;re unable to. You could get a guarantor loan if you have a
            poor credit record, or if you&apos;ve not borrowed before.
          </p>

          <p className='LoanRepaymentCalculator-more-info-title'>Business loans</p>

          <p className='LoanRepaymentCalculator-more-info-text'>
            This type of loan can only be used for business purposes and it must be paid back over
            time, with interest. For example, a business loan can be used for hiring more staff,
            buying equipment, marketing and improving cash flow.
          </p>
        </div>
      </details>
    </Card>
  )
}

export default LoanRepaymentCalculator
